import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import PopupBox from '../PopupBox.js';


import Countdown from '../Countdown.js';


export default class DoubleNegative extends React.Component {
  render() {

    //generate double negative question
    const question = generateDoubleNegativeQuestion(this.props.question, this.props.nots1, this.props.nots2, this.props.fail_message);


    //handle the click on one of the buttons
    const handleClick = (e) => {

      //if the id value of the button and compare to the correct answer
      if( parseInt(e.target.getAttribute("value")) == question.correct_answer)
     { 
        this.props.setResult(true, this)
      }
      else
      {
        this.props.setResult(false, this)
      }
    };


   

    return (
      <PopupBox position={this.props.position} getPos={this.props.getPos} question={this}>

      <Countdown time_allowed={25} getPos={this.props.getPos} question={this} setResult={this.props.setResult}></Countdown>

     
        <h2 className="text-danger">{question.question}</h2>
        
        <br></br>

        <div className="d-flex justify-content-center">
          <ButtonToolbar>
            <Button value="0" onMouseDown={handleClick} className="mr-3" variant="success" size="lg">{question.answers[0]}</Button>  
            <Button value="1" onMouseDown={handleClick} className="mr-3" variant="danger" size="lg">{question.answers[1]}</Button>
          </ButtonToolbar>
        </div>

      </PopupBox>

    );
  }
}





function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
  }

  return array;
  }





  function generateDoubleNegativeQuestion(question_text, n1, n2)
  {
      n1 = parseInt(n1)
      n2 = parseInt(n2)

      var question_array = question_text.split("_____")


      var v = 1; // sentence without any nots would mean agreeing to the ts and cs, so v is positive at thr start
      
      var nots = " " // add a space to the sentence if no nots added

      var num_nots = n1 // generate number of nots in first part of sentence

     
      //loop through number of nots for first location
      for(var i = 0; i < num_nots; i ++)
      {
          nots += "not " // add a not to the sentence

          v *= -1 // flip the meaning of the sentence
      }

     

      
      var nots2 = " " // add a space to the sentence if no nots added

      if(n2)
      {
       
          //loop through number of nots for second location
          var num_nots2 = n2

          for(var i = 0; i < num_nots2; i ++)
          {
              nots2 += "not " // add a not to the sentence

              v *= -1 // flip the meaning of the sentence
          }


      }


      var question;

      if(n2)
      {
          question = question_array[0] + nots + question_array[1] + nots2 + question_array[2]
      }
      else
      {
          question = question_array[0] + nots + question_array[1]
      }

      //console.log(question)
      //console.log(v)

      //if v is positive, agreeing would mean accepting (and failing the test)
      //if v is negative, agreeing would mean declining

      var correct_answer

      if(v < 0)
      {
          correct_answer = 0
      }
      else
      {
          correct_answer = 1
      }

      return {question: question, answers:["Yes", "No"], correct_answer: correct_answer}

  }

  function generateShame(question, amount)
  {
      var shames = shuffle( ["like to kill kittens", "am smelly", "have bad breath", "am not very clever", "hate free money", "like being a loser", "have no friends", "am really annoying", "like wasting my own time", "have a small brain", "want to remain unsuccessful"] )

      var no = "No, I " + shames.pop()

      if(amount > 1)
      {
          for(var i = 1; i < amount; i ++)
          {
              no += " and " + shames.pop()
          }
      }
      
      

      return {question: question, answers:["Yes", no], correct_answer: 1}

  }




  function generateQuestionAnswers(question, n1)
  {




      var v = 1; // sentence without any nots would mean agreeing to the ts and cs, so v is positive at thr start
      
      var nots = " "

      var num_nots = Math.floor(Math.random()*(n1+1)) // generate number of nots fir first answer
     
      //loop through number of nots for first answer
      for(var i = 0; i < num_nots; i ++)
      {
          nots += "not " // add a not to the sentence

          v *= -1 // flip the meaning of the sentence
      }

      var answer1 = "I do" +nots+ "agree"

      var answer2 = "I do not" +nots+ "agree"

      

      var correct_answer

      if(v < 0)
      {
          correct_answer = 0
      }
      else
      {
          correct_answer = 1
      }

      return {question: question, answers:[answer1, answer2], correct_answer: correct_answer}

  }





  var questions = new Array();


  questions.push( generateDoubleNegativeQuestion("Do you agree_____to_____be bound by these terms and conditions?", 1, 2, "You ageed to Big Corp's Ts & Cs") )

  questions.push( generateDoubleNegativeQuestion("Do you agree_____to_____receive our newsletter?", 1, 2, "You ageed to receive Big Corp's newslatter") )

  questions.push( generateDoubleNegativeQuestion("Do you agree_____to_____enable notifications?", 1, 2) )

  questions.push( generateDoubleNegativeQuestion("Do you agree_____to_____enable notifications?", 1, 2) )


  questions.push( generateDoubleNegativeQuestion("Would you like to_____enable notifications?", 5) )


  questions.push( generateDoubleNegativeQuestion("We would like permission_____to_____enable ad cookies, OK?", 1, 2) )

  questions.push( generateDoubleNegativeQuestion("Do we have your permission_____to_____enable ad cookies, Do you agree?", 1, 2) )


  questions.push( generateShame("Would you like to receive our weekly email roundup?", 1) )

  questions.push( generateShame("Would you like to receive our weekly email roundup?", 2) )

  questions.push( generateShame("Would you like to receive our weekly email roundup?", 3) )

  questions.push( generateShame("Would you like to receive our weekly email roundup?", 4) )

  questions.push( generateShame("Would you like to receive our weekly email roundup?", 5) )

  
  questions.push( generateQuestionAnswers("Do you want to sign up to our mailing list?", 2) )


  

  //console.log(questions);



